function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 28.0001C21.732 28.0001 28 21.7321 28 14.0001C28 6.26804 21.732 0 14 0C6.26801 0 0 6.26804 0 14.0001C0 21.7321 6.26801 28.0001 14 28.0001Z",
  fill: "#627EEA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5599 3.49805V11.2597L20.1198 14.1914L13.5599 3.49805Z",
  fill: "white",
  fillOpacity: 0.602
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5599 3.49805L7 14.1914L13.5599 11.2597V3.49805Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5599 19.2205V24.4944L20.1235 15.4124L13.5599 19.2205Z",
  fill: "white",
  fillOpacity: 0.602
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5599 24.4944V19.2205L7 15.4124L13.5599 24.4944Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5599 17.9995L20.1198 14.1914L13.5599 11.2597V17.9995Z",
  fill: "white",
  fillOpacity: 0.2
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7 14.1914L13.5599 17.9995V11.2597L7 14.1914Z",
  fill: "white",
  fillOpacity: 0.602
});
function SvgTokenEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenEth);
export default __webpack_public_path__ + "static/media/token-eth.cca7ba885ae9460abcc87035cd9bbb4e.svg";
export { ForwardRef as ReactComponent };